import React, { useState } from 'react';
import './Panel.css'
import FilterIcon from '../../Components/SideBar/assets/icons/filterIcon.png';
import Button from '../Button/Button';
import { useEffect } from 'react';

const Panel =
    ({
        children,
        style,
        className,
        setUpdating = false,
        setInserting = false,
        inserting = false,
        updating = false,
        enableEdit = false,
        canEdit = false,
        canSaveAfterEdit = true,
        forcedEdit = false,
        putFunction,
        enableNewRecord = false,
        canNewRecord = false,
        canSaveAfterNewRecord = true,
        forcedNewRecord = false,
        forcedDeleteButton = false,
        postFunction,
        enableDelete = false,
        canDelete = false,
        newRecordNameButton = 'Novo',
        updateNameButton = 'Editar',
        insertNameButton = 'Adicionar',
        deleteNameButton = 'Excluir',
        saveNameButton = 'Salvar',
        cancelNameButton = 'Cancelar',
        cancelFunction,
        deleteFunction,
        canViewCRUD = false,
        readOnly,
        recordsSelected,
        viewOnlyOneRecordCRUD = false,
        restrictPanel = false,
        messageRestrictPanel,
        records,
        panelAttributesToShowInDetail,
        titlePage,
        resetVariables,
        reloadFilter,
        componentLeftButtons,
        componentLeftFilter,
        componentRightFilter,
        componentRightButtons,
        titleStyleAdditional,
        subtitlesPanelBottom,
        filterAction,
        setHigherRegisterSelected,
        resetHigherRegisterInserting = false,
        dataListedAttributes,
        attributeList,
        withoutCrud,
        onUpdateIdSelected,
        allowsMultipleInserts = false,
        allowsMultipleUpdates = false,
        setDetailRecord
    }) => {
        const [insertingProcess, setInsertingProcess] = useState(false);
        const [updatingProcess, setUpdatingProcess] = useState(false);
        const [isMobile, setIsMobile] = useState(window.innerWidth < 786);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 786);
            };

            window.addEventListener('resize', handleResize);

            return () => window.removeEventListener('resize', handleResize);
        }, []);
        const buttonDeleteSyled = {
            minWidth: '80px',
            padding: '0px 5px 0px 5px',
            margin: '2.5px',
            float: 'right',
            color: !canDelete ? '#201b2387' : '#f21818',
            textAlign: 'center',
            fontWeight: '600',
            fontSize: '0.8em'
        };

        const buttonCancelSyled = {
            minWidth: '80px',
            padding: '0px 5px 0px 5px',
            margin: '2.5px',
            float: 'right',
            color: 'white',
            backgroundColor: '#f21818',
            fontWeight: '600',
            textAlign: 'center',
            fontSize: '0.8em'
        };

        const buttonInsertSyled = {
            minWidth: '80px',
            padding: '0px 5px 0px 5px',
            margin: '2.5px',
            float: 'right',
            color: canNewRecord ? 'green' : '#201b2387',
            fontWeight: '600',
            textAlign: 'center',
            fontSize: '0.8em'
        };

        const buttonUpdateSyled = {
            minWidth: '80px',
            padding: '0px 5px 0px 5px',
            margin: '2.5px',
            float: 'right',
            color: 'white',
            backgroundColor: canEdit ? 'green' : '#201b2387',
            fontWeight: '600',
            textAlign: 'center',
            fontSize: '0.8em'
        };

        const buttonAddOrEditSyled = {
            minWidth: '80px',
            padding: '0px 5px 0px 5px',
            margin: '2.5px',
            float: 'right',
            color: 'white',
            backgroundColor: (canNewRecord || canEdit) && !mandatoryAttributesPending() ? 'green' : '#201b2387',
            fontWeight: '600',
            textAlign: 'center',
            fontSize: '0.8em'
        };

        const titleControlPanelStyle = {
            fontSize: '1.2em',
            width: '100%',
            justifyContent: 'space-between',
            textAlign: 'center',
            display: 'flex',
            minHeight: isMobile ? '100px' : '56px',
            height: isMobile ? '100px' : '56px',
            flexDirection: isMobile ? 'column' : 'row',
            backgroundColor: 'white'
        };

        const titleStyle = {
            textAlign: 'center',
            display: 'flex',
            marginLeft: '10px',
            fontSize: '1em',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            backgroundColor: 'white',
            ...titleStyleAdditional
        };

        const textControlPanel = {
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            display: 'flex',
            marginRight: '10px'
        };

        function mandatoryAttributesPending() {
            let pending = false

            if ((!canSaveAfterNewRecord && inserting) || (!canSaveAfterEdit && updating)) {
                return true
            }

            if ((dataListedAttributes && dataListedAttributes[0] && dataListedAttributes[0].constructorList.length > 0)
                && (attributeList && attributeList.length > 0)) {
                dataListedAttributes[0].constructorList.forEach(element => {
                    const attributeDataFrontend = attributeList.find(obj => obj.name === element.field) || {};

                    if ((attributeDataFrontend && (!attributeDataFrontend.value && attributeDataFrontend.value !== 0)) && (attributeDataFrontend.isMandatory === 'S' || element.isMandatory === 'S')) {
                        pending = true
                    }
                });
            }
            return pending
        }

        function getSetUpdateButton() {
            if (forcedEdit || enableEdit) {
                return <Button
                    clickMethod={() => {
                        if (setUpdating) {
                            setUpdating(true);
                        }
                    }}
                    buttonName={updateNameButton}
                    style={buttonUpdateSyled}
                    disabled={!canEdit}
                />
            }
        }

        function getSetInsertButton() {
            if (forcedNewRecord || enableNewRecord) {
                return <Button
                    clickMethod={() => {
                        if (setInserting) {
                            if (onUpdateIdSelected) {
                                onUpdateIdSelected([])
                            }

                            setInserting(true)

                            if (resetVariables) {
                                resetVariables()
                            }

                            if (resetHigherRegisterInserting) {
                                setHigherRegisterSelected([])
                            }
                        }
                    }}
                    buttonName={newRecordNameButton}
                    style={buttonInsertSyled}
                    disabled={!canNewRecord}
                />
            }
        }

        function getDeleteButton() {
            if (!inserting && !updating && enableDelete) {
                return <Button
                    clickMethod={() => {
                        deleteFunction(recordsSelected);
                        if (reloadFilter) {
                            reloadFilter(true);
                        }

                        if (onUpdateIdSelected) {
                            onUpdateIdSelected([])
                        }
                    }
                    }
                    buttonName={deleteNameButton}
                    style={buttonDeleteSyled}
                    disabled={!canDelete}
                />
            }
        }

        function getEditButton() {
            if (!inserting && updating && canEdit) {
                return <Button
                    clickMethod={async () => {
                        if (!allowsMultipleUpdates && !updatingProcess) {
                            try {
                                setUpdatingProcess(true)
                                const returnValue = await putFunction();

                                if (returnValue || returnValue === null) {
                                    if (setUpdating) {
                                        setUpdating(false);
                                    }

                                    if (reloadFilter) {
                                        await reloadFilter(true);
                                    }
                                }
                            } finally {
                                setUpdatingProcess(false)
                            }
                        }
                    }
                    }
                    disabled={mandatoryAttributesPending()}
                    buttonName={saveNameButton}
                    style={buttonAddOrEditSyled}
                />
            }
        }

        function getNewRecordButton() {
            if (inserting && !updating) {
                return <Button
                    clickMethod={async () => {
                        if (!allowsMultipleInserts && !insertingProcess) {
                            try {
                                setInsertingProcess(true)
                                const returnValue = await postFunction();

                                if (returnValue || returnValue === null) {
                                    if (setInserting) {
                                        setInserting(false);
                                    }

                                    if (reloadFilter) {
                                        await reloadFilter(true);
                                    }
                                }
                            } finally {
                                setInsertingProcess(false)
                            }
                        }
                    }
                    }
                    buttonName={insertNameButton}
                    disabled={mandatoryAttributesPending()}
                    style={buttonAddOrEditSyled}
                />
            }
        }

        function getCancelButton() {
            if (inserting || updating) {
                return <Button
                    clickMethod={async () => {
                        if (cancelFunction) {
                            await cancelFunction();
                        }

                        if (setInserting) {
                            setInserting(false);
                        }

                        if (setUpdating) {
                            setUpdating(false);
                        }
                    }
                    }
                    buttonName={cancelNameButton}
                    style={buttonCancelSyled}
                />
            }
        }

        function filterAtributte() {
            if (!filterAction) {
                return null
            }
            return (
                <img src={FilterIcon}
                    style={{
                        maxHeight: '17px',
                        maxWidth: '17px',
                        width: '17px',
                        margin: '0px',
                        cursor: 'pointer',
                        marginLeft: '5px'
                    }}
                    onClick={filterActionUpdate}
                />
            )
        }

        function filterActionUpdate() {
            filterAction(true)
        }

        function getPanelContent() {
            if (!canViewCRUD) {
                return;
            }

            if (viewOnlyOneRecordCRUD && recordsSelected && recordsSelected.length > 1) {
                return (
                    <Panel style={titleControlPanelStyle}>
                        <Panel style={titleStyle}>
                            {componentLeftFilter ? componentLeftFilter : null}
                            <div style={{ display: 'flex', width: '100%', fontWeight: 'bold' }}>
                                {titlePage}
                            </div>
                            {filterAtributte()}
                            {componentRightFilter ? componentRightFilter : null}
                        </Panel>
                        <Panel style={textControlPanel}>
                            Selecione somente 01 registro.
                        </Panel>
                    </Panel>
                )
            }

            if (restrictPanel) {
                return (
                    <Panel style={titleControlPanelStyle}>
                        <Panel style={titleStyle}>
                            {componentLeftFilter ? componentLeftFilter : null}
                            <div style={{ display: 'flex', width: '100%', fontWeight: 'bold' }}>
                                {titlePage}
                            </div>
                            {filterAtributte()}
                            {componentRightFilter ? componentRightFilter : null}
                        </Panel>
                        <Panel style={textControlPanel}>
                            {messageRestrictPanel}
                        </Panel>
                    </Panel>
                )
            }

            let buttons;
            let buttonDelete;
            if (!readOnly) {
                if (!inserting || !updating) {
                    buttons =
                        <>
                            {getSetUpdateButton()}
                            {getSetInsertButton()}
                        </>
                }

                if (inserting || updating) {
                    buttons =
                        <>
                            {getEditButton()}
                            {getNewRecordButton()}
                            {getCancelButton()}
                        </>
                }

                if ((forcedDeleteButton || (recordsSelected && recordsSelected.length === 1) || enableDelete) && (!inserting || !updating)) {
                    buttonDelete =
                        <>
                            {getDeleteButton()}
                        </>
                }
            }

            return (
                <Panel style={titleControlPanelStyle}>
                    <Panel style={titleStyle}>
                        {componentLeftFilter ? componentLeftFilter : null}
                        <div style={{ display: 'flex', width: '100%', fontWeight: 'bold' }}>
                            {titlePage}
                        </div>
                        {filterAtributte()}
                        {componentRightFilter ? componentRightFilter : null}
                    </Panel>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                        {componentLeftButtons}
                        {buttons}
                        {buttonDelete}
                        {componentRightButtons}
                    </div>
                </Panel>
            )

        }

        function getSubtitlesPanelContent() {
            if (subtitlesPanelBottom) {
                return (
                    subtitlesPanelBottom
                )
            }
        }

        const subtitlesPanelContent = getSubtitlesPanelContent()

        return (
            <>
                <div style={style} id='main-panel' className={className}>
                    {withoutCrud ? null : getPanelContent()}
                    {children}
                </div>
                {subtitlesPanelContent}
            </>
        );
    };

export default Panel;
